export default "__VITE_PUBLIC_ASSET__bc312858__"